<template>
    <div id="modal_fuzzy_matches" class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    Fuzzy Matches:
                    <span style="margin-left: 2em">{{ this.partSelected }}</span>
                </p>
                <button class="delete" aria-label="close" @click="closeFuzzyMatchModal"></button>
            </header>
            <section class="modal-card-body">
                <div style="display: flex; justify-content: center; align-items: flex-end">
                    <div id="fuzzy_part_matches" v-if="fuzzyPartMatches.length > 0">
                        <table id="fuzzy_table" class="table is-striped">
                            <thead>
                                <tr>
                                    <th>
                                        <label class="checkbox">
                                            <input v-model="selectAll" type="checkbox" />
                                        </label>
                                    </th>
                                    <th>Possible Alternate</th>
                                    <th>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(match, idx) in fuzzyPartMatches" :key="`fuzzy_${idx}`">
                                    <td>
                                        <label class="checkbox">
                                            <input v-model="selection" :value="match.part_alternate"
                                                type="checkbox" :checked="selectAll" />
                                        </label>
                                    </td>
                                    <td v-html="match.html"></td>
                                    <td style="text-align: center">{{ match.distance }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>No Matches</div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="buttons is-right" style="width: 100%">
                    <button class="button is-info" @click="replaceFuzzyMatch" :disabled="selection.length != 1">
                        Replace
                    </button>
                    <button class="button is-success" @click="researchFuzzyMatch">
                        Research {{ selection.length }}
                    </button>
                    <button class="button is-danger" @click="closeFuzzyMatchModal">
                        Close
                    </button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalFuzzyMatches",
    props: {
        partSelected: {
            type: String,
            required: true,
        },
        fuzzyPartMatches: {
            type: Array,
            requried: true,
        },
        fuzzySelection: {
            type: Array,
            requried: true,
        },
        fuzzySelectAll: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selectAll: '',
            selection: [],
        }
    },
    mounted() {
        this.selection = this.fuzzySelection
        this.selectAll = this.fuzzySelectAll
    },
    methods: {
        doClose() {
            this.$emit('doClose')
        },
        doReplace() {
            this.$emit('doReplace')
        },
        doResarch() {
            this.$emit('doResarch')
        },
    }
};
</script>